import React from 'react';
import CustomButton from '@components/common/CustomButton';

export default function ContactAndRequestButtons(): React.JSX.Element {
  return (
    <div className="space-x-4">
      <CustomButton href="https://renovefudosan.com/lp/inquiry_check/" label="お問い合わせ" handleClick={() => {}} />
      <CustomButton href="https://renovefudosan.com/request/" label="資料請求" handleClick={() => {}} />
    </div>
  );
}
